var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentorSuggestionLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1300,
    height: 744,
    viewBox: "0 0 1300 744",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10L100.152 10C155.381 10 200.152 54.7715 200.152 110L200.152 229L200.152 520C200.152 575.228 244.924 620 300.152 620L743.61 620C775.09 620 800.61 645.52 800.61 677V677C800.61 708.48 826.129 734 857.61 734L1300 734",
    stroke: "#BCB2FF",
    strokeOpacity: 0.1,
    strokeWidth: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorSuggestionLines);
export default __webpack_public_path__ + "static/media/MentorSuggestionLines.c9995dda39e39e332eb68139e78dbda2.svg";
export { ForwardRef as ReactComponent };